enum ReportTypes {
  basic = 'Basic',
  premium = 'Premium',
}

export default ReportTypes;
